import LinkComponent from "next/link";
// Cast to fix React 17 + @types/react 18 compatibility issue
const Link = LinkComponent as any;
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { Badge, ContactBadgeContainer } from "./styles";
import SVGMail from "@/lib/svg/SVGMail";

export const RotatingContactBadge: React.FC = () => {
  const router = useRouter();
  const { locale, pathname } = router;
  const badgeRef = useRef<HTMLAnchorElement>(null);

  return (
    <ContactBadgeContainer $visible={pathname !== "/contacts"}>
      <Link href="/contacts" passHref>
        <Badge ref={badgeRef}>
          <SVGMail />
        </Badge>
      </Link>
    </ContactBadgeContainer>
  );
};

export default RotatingContactBadge;
